import React, { useEffect, useState } from 'react'
import "./Header.css"
import { BsFillEnvelopeFill } from 'react-icons/bs'
import { NavLink, useNavigate } from 'react-router-dom';
import LogoImg from '../../Images/Mandli/WhiteLogo.svg'
import { getIsLogin, getToken } from '../../Helper/Token';
import axios from 'axios';
// import UserIcon from '../../Images/Mandli2024/MaleUser.svg'
import { getPatchUserDetails, getUserDetails } from '../../Api';
import { CiMail } from "react-icons/ci";
import { FaInstagram, FaYoutube } from "react-icons/fa";
import district_btn from '../../Images/Mandli/district_btn.svg'


function Header({ isHeaderFixed }) {
  const navigate = useNavigate()

  // Toggle Menu
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  // Get Token
  const token = getToken()
  const isLogin = getIsLogin()

  // Get User Details
  const [userDetails, setUserDetails] = useState({})
  const fetchUserDetails = () => {
    getToken();
    axios.patch(getPatchUserDetails)
      .then((res) => {
        axios.get(`${getUserDetails}/${res.data.user._id}`)
          .then((res) => {
            setUserDetails(res.data.result)
          })
      })
  }
  useEffect(() => {
    fetchUserDetails()
  }, [])

  // Logout 
  const handleLogOut = (e) => {
    e.preventDefault();
    navigate("/")
    setMenuOpen(false)
    localStorage.clear()
    sessionStorage.clear()
  }

  // Sticky Header
  const [isSticky, setIsSticky] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset >= 50) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // {`main-header ${isSticky ? 'sticky' : ''}`}

  return (
    <div className={`Header`}>

      {/* <div className={`top-header ${isSticky ? 'sticky' : ''}`}>
        <div className="header-top-area-shape"></div>
        <div className='container'>
          <div className='top-content'>
            <div className='social-media' >
              <a href="mailto:commoneventsplanningteam@gmail.com" ><BsFillEnvelopeFill />commoneventsplanningteam@gmail.com</a>
              <ul>
                <li><a href="https://www.instagram.com/mandli_garba/?hl=en" target='_blank'><FaInstagram style={{fontSize: "22px"}} /></a></li>
                <li><a href="https://www.youtube.com/@Mandli_Garba" target='_blank'><FaYoutube style={{fontSize: "24px"}} /></a></li>
              </ul>
            </div>
            <div className='top-right'>
              {
                !isLogin ?
                  <><NavLink to='/login'>Login</NavLink> / <NavLink to='/signup'>Sign Up</NavLink></>
                  :
                  <NavLink to='/profile'><img src={UserIcon} alt="" /> Hello, {userDetails?.name}</NavLink>
              }
            </div>
          </div>
        </div>
      </div> */}

      <div className={`main-header rest header${isSticky ? 'sticky' : ''}`}>
        <div className="container">
          <div className='header-main'>
            <div className='userbox-lg-search logo'>
              <NavLink to="/" onClick={() => navigate('/')}><img src={LogoImg} width={"200"} /></NavLink>
            </div>
            <div className='header-menu'>
              <div className='nav-menu'>
                <ul>
                  <li> <NavLink to="/about" >About</NavLink> </li>
                  <li> <NavLink to="/gallery" >Gallery</NavLink> </li>
                  <li> <NavLink to="/support" >Support</NavLink> </li>
                </ul>
              </div>
            </div>
          </div>

          <div className='header-main mobile'>

            <div className='header-menu'>
              <button className={menuOpen ? "menu-toggler active" : "menu-toggler"} id='menu-toggler' type="button" onClick={toggleMenu}>
                <span className="line"></span>
                <span className="line"></span>
                <span className="line"></span>
              </button>
              <div className={menuOpen ? "das-header mobile-nav-menu show" : "das-header mobile-nav-menu"} id="nav-menu">

                <div className="mobile-menu">
                  <ul>
                    {/* <li className="contact">
                      <div className='profile-gothrow'>
                        <div className='imge_profile'>
                          <img src={UserIcon} alt="" />
                        </div>
                        {
                          !isLogin ?
                            <div className='profile_text_login_sign'>
                              <h1>YOUR PROFILE</h1>
                              <div className='main-heading m-0'>
                                <NavLink to='/login' className="effect1" data-hover="Login">Login</NavLink> / <NavLink className="effect1" to='/signup' data-hover="Sign Up">Sign Up</NavLink>
                              </div>
                            </div> :
                            <NavLink to="/profile" className='profile_text_login_sign' onClick={() => setMenuOpen(false)}>
                              <h1>Hi, {userDetails?.name}</h1>
                              <p>My Profile / <NavLink onClick={(e) => handleLogOut(e)}>Logout</NavLink></p>
                            </NavLink>
                        }
                      </div>
                    </li> */}
                    <li className="contact" onClick={() => setMenuOpen(false)}><NavLink to="/">HOME</NavLink></li>
                    {/* {isLogin && <li className="contact" onClick={() => setMenuOpen(false)}><NavLink to="/orders">ORDERS</NavLink></li>} */}
                    <li className="contact" onClick={() => setMenuOpen(false)}><NavLink to="/about">ABOUT</NavLink></li>
                    <li className="contact" onClick={() => setMenuOpen(false)}><NavLink to="/gallery">GALLERY</NavLink></li>
                    <li className="contact" onClick={() => setMenuOpen(false)}><NavLink to="/support">SUPPORT</NavLink></li>
                  </ul>
                  <div className="banner-wrapper main-heading what_is_mandli_sidebar">
                    {/* <h2 className="sidebar-fonts-smaller and-fonts-sidebar"> book passes<span> on</span> </h2>
                    <NavLink className="align-center" to="https://link.district.in/DSTRKT/MandliGarbaAhmedabadPartnerSocial" target="_blank" onClick={() => setMenuOpen(false)} >
                      <img src={district_btn} className='district-book-btn' alt="book on district" />
                    </NavLink> */}
                    <h2 className="sidebar-fonts-smaller and-fonts-sidebar pb-3" style={{marginTop:"0px"}}>Tickets Coming soon</h2>
                  </div>
                </div>
              </div>
            </div>

            <div className='userbox-lg-search logo'>
              <NavLink to="/" onClick={() => navigate('/')}><img src={LogoImg} width={"200"} /></NavLink>
            </div>


            <div className='header-menu'>
              <div className='nav-menu'>
                <ul className='p-0'>
                  <li className='button p-0'>
                    <NavLink className="Insta_n-clr" to="https://www.instagram.com/mandli_garba/?hl=en" target='_blank' >
                      <FaInstagram />
                    </NavLink>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}



export default Header